import { fieldsReducer as fields } from '../../features/fields/fields-slice.js';
import { loadReducerError } from '../../utils/errors.js';
import { registerFieldsToInclude } from '../fields/fields-actions.js';
import { buildTemplatesManager, } from '../templates/templates-manager.js';
/**
 * A manager in which result templates can be registered and selected based on a list of conditions and priority.
 * @param engine (HeadlessEngine) The `HeadlessEngine` instance of your application.
 * @returns (ResultTemplatesManager<Content, State>) A new result templates manager.
 */
export function buildResultTemplatesManager(engine) {
    if (!loadResultTemplatesManagerReducers(engine)) {
        throw loadReducerError;
    }
    const { registerTemplates: coreRegisterTemplates, selectTemplate, selectLinkTemplate, } = buildTemplatesManager();
    return {
        registerTemplates: (...newTemplates) => {
            coreRegisterTemplates(...newTemplates);
            const fields = [];
            newTemplates.forEach((template) => {
                template.fields && fields.push(...template.fields);
            });
            engine.dispatch(registerFieldsToInclude(fields));
        },
        selectTemplate,
        selectLinkTemplate,
    };
}
function loadResultTemplatesManagerReducers(engine) {
    engine.addReducers({ fields });
    return true;
}
